import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatAnswerForDisplay } from './answerDisplayFormatting';

const AnswerDisplayText = ({ children, sx = {} }) => {
  const blocks = formatAnswerForDisplay(children);

  return (
    <Box sx={sx}>
      {blocks.map((block, blockIndex) => {
        if (block.type === 'numbered-list' || block.type === 'bullet-list') {
          return (
            <Box
              component={block.type === 'numbered-list' ? 'ol' : 'ul'}
              key={`${block.type}-${blockIndex}`}
              sx={{ mt: blockIndex ? 0.75 : 0, mb: 0, pl: { xs: 2.6, sm: 3 }, '& li + li': { mt: 0.55 } }}
            >
              {block.items.map((item, itemIndex) => (
                <Typography component="li" key={`${itemIndex}-${item}`} sx={{ font: 'inherit', lineHeight: 'inherit', color: 'inherit' }}>
                  {item}
                </Typography>
              ))}
            </Box>
          );
        }

        return (
          <Typography
            component="p"
            key={`paragraph-${blockIndex}`}
            sx={{ m: 0, mt: blockIndex ? 0.8 : 0, font: 'inherit', lineHeight: 'inherit', color: 'inherit' }}
          >
            {block.text}
          </Typography>
        );
      })}
    </Box>
  );
};

export default AnswerDisplayText;

